const common = {
  "nav.categories": "Categorias",
  "nav.guides": "Guias",
  "nav.about": "Sobre",
  "nav.faq": "Perguntas",
  "nav.cta": "Comprar agora",
  "nav.home": "Início",
  "nav.shoppingGuide": "Guia de compras",

  "lang.en": "English",
  "lang.fr": "Français",
  "lang.de": "Deutsch",
  "lang.es": "Español",
  "lang.pt": "Português",

  "hero.badge": "Central de recursos do Basetao Spreadsheet",
  "hero.title": "Basetao Spreadsheet: produtos, vendedores e guias de compra",
  "hero.subtitle":
    "Uma central de recursos independente e limpa que ajuda você a explorar categorias de produtos Basetao, links selecionados e dicas práticas de compra, tudo em um só lugar.",
  "hero.cta1": "Basetao Spreadsheet",
  "hero.cta2": "Comprar agora",
  "hero.dropdownLabel": "Ir para uma categoria",

  "cat.dropdownPlaceholder": "Escolha uma categoria…",

  "catSection.eyebrow": "Compre na planilha",
  "catSection.title": "Explorar categorias",
  "catSection.subtitle":
    "Navegue pelas categorias de produtos mais populares do Basetao Spreadsheet e acesse diretamente os itens que você procura.",
  "catSection.shopNow": "Comprar",

  "cat.shoes": "Tênis",
  "cat.hoodies": "Moletons / Blusas",
  "cat.tshirts": "Camisetas",
  "cat.jackets": "Jaquetas",
  "cat.pants": "Calças / Shorts",
  "cat.headwear": "Bonés e chapéus",
  "cat.sets": "Conjuntos",
  "cat.underwear": "Roupa íntima",
  "cat.jersey": "Camisas esportivas",
  "cat.accessories": "Acessórios",
  "cat.bags": "Bolsas",
  "cat.belts": "Cintos",
  "cat.perfumes": "Perfumes",
  "cat.other": "Outros itens",

  "guides.eyebrow": "Guias e recursos",
  "guides.title": "Guias populares",
  "guides.subtitle":
    "Artigos originais e práticos que explicam como usar o Basetao Spreadsheet e comprar com confiança.",
  "guides.readMore": "Ler o guia",
  "guides.card.badge": "Guia para iniciantes",
  "guides.card.title": "Guia do Basetao Spreadsheet: o que é e como usar",
  "guides.card.excerpt":
    "Um guia claro e amigável para iniciantes sobre o que é um Basetao Spreadsheet, como lê-lo e como usá-lo para encontrar produtos, vendedores e preços melhores.",

  "about.eyebrow": "O que é?",
  "about.title": "O que é um Basetao Spreadsheet?",
  "about.p1":
    "Um Basetao Spreadsheet é uma lista compartilhada e organizada de produtos, links, vendedores e notas coletada por compradores que usam o Basetao para pedir em marketplaces chineses e enviar internacionalmente. Em vez de buscar do zero, você parte de um conjunto selecionado de itens que outros compradores já encontraram e verificaram.",
  "about.p2":
    "Como uma planilha é fácil de filtrar, ordenar e compartilhar, ela é uma forma prática de comparar produtos em categorias como tênis, moletons, camisetas, jaquetas, bolsas e acessórios, além de acompanhar os vendedores e as notas de controle de qualidade que importam na hora de pedir.",
  "about.point1.title": "Produtos selecionados",
  "about.point1.text":
    "Links para itens específicos são organizados por categoria, para você gastar menos tempo buscando e mais tempo comparando.",
  "about.point2.title": "Notas de vendedores e QC",
  "about.point2.text":
    "Notas úteis sobre vendedores e observações de controle de qualidade ajudam você a identificar opções confiáveis antes de pedir.",
  "about.point3.title": "Compartilhável e atualizável",
  "about.point3.text":
    "Planilhas são fáceis de compartilhar e atualizar, para que a lista continue atual conforme novos produtos e notas são adicionados.",

  "features.eyebrow": "Por que usar",
  "features.title": "Por que usar um Basetao Spreadsheet?",
  "features.subtitle":
    "Algumas razões pelas quais os compradores confiam em uma planilha organizada ao pedir pelo Basetao.",
  "features.f1.title": "Economize tempo",
  "features.f1.text": "Comece por uma lista pronta em vez de navegar por dezenas de páginas uma a uma.",
  "features.f2.title": "Compare com facilidade",
  "features.f2.text": "Veja produtos lado a lado por categorias, vendedores e preços.",
  "features.f3.title": "Mantenha-se organizado",
  "features.f3.text": "Guarde seus favoritos, notas e detalhes de controle de qualidade em um só lugar.",
  "features.f4.title": "Compre com contexto",
  "features.f4.text":
    "Combine links de produtos com notas de vendedores e QC para tomar decisões mais seguras.",

  "faq.eyebrow": "Perguntas",
  "faq.title": "Perguntas frequentes",
  "faq.q1": "O que é um Basetao Spreadsheet?",
  "faq.a1":
    "É uma lista compartilhada e organizada de produtos, links, vendedores e notas que os compradores usam para encontrar e comparar itens pedidos pelo Basetao.",
  "faq.q2": "Este site é afiliado ao Basetao?",
  "faq.a2":
    "Não. O BasetaoSheet.casa é um recurso informativo independente e não é necessariamente afiliado ao Basetao, a menos que seja indicado explicitamente.",
  "faq.q3": "Como uso as categorias desta página?",
  "faq.a3":
    "Escolha uma categoria no menu suspenso ou na grade e você será levado à página de produto correspondente no nosso site principal.",
  "faq.q4": "Preciso de uma conta para navegar?",
  "faq.a4": "Não, você pode explorar categorias e guias livremente sem se cadastrar.",
  "faq.q5": "Os preços e vendedores são garantidos?",
  "faq.a5":
    "Preços, disponibilidade e dados dos vendedores podem mudar. Sempre revise a página do produto no site principal antes de pedir.",

  "cta.title": "Pronto para explorar todo o catálogo?",
  "cta.subtitle": "Navegue por todas as categorias no site principal e encontre os itens que você procura.",
  "cta.button": "Comprar agora",

  "footer.tagline":
    "O Basetao Sheet é uma central de recursos independente para o Basetao Spreadsheet, ajudando compradores a explorar produtos, categorias e guias.",
  "footer.disclaimer": "Recurso informativo independente. Não necessariamente afiliado ao Basetao.",
  "footer.explore": "Explorar",
  "footer.resources": "Recursos",
  "footer.legal": "Legal",
  "footer.guide": "Guia do Spreadsheet",
  "footer.home": "Início",
  "footer.categories": "Categorias",
  "footer.about": "Sobre",
  "footer.faq": "Perguntas",
  "footer.rights": "Todos os direitos reservados.",

  "home.breadcrumb": "Início",
  "article.notFound": "Artigo não encontrado",
  "article.faqHeading": "Perguntas frequentes",
  "article.conclusionHeading": "Conclusão",

  "notFound.title": "Página não encontrada",
  "notFound.subtitle": "A página que você procura não existe ou pode ter sido movida.",
};

export default common;